import React from "react";
import { NAME, ROLES, BULLETS, LINKS } from "content";

const Bullet = ({ item }) => {
  if (typeof item === "string") return <li>{item}</li>;
  const { text, link, tail, soft } = item;
  return (
    <li className={soft ? "soft" : undefined}>
      {text}
      {link && (
        <a href={link.href} target="_blank" rel="noreferrer">
          {link.label}
        </a>
      )}
      {tail}
    </li>
  );
};

const Identity = () => (
  <div className="bio">
    <h1 className="name">{NAME}</h1>

    <ul className="roles">
      {ROLES.map((role) => (
        <li key={role}>{role}</li>
      ))}
    </ul>

    <ul className="facts">
      {BULLETS.map((item, i) => (
        <Bullet key={i} item={item} />
      ))}
    </ul>

    <ul className="links">
      {LINKS.map(({ label, href }) => (
        <li key={label}>
          <a href={href} target="_blank" rel="noreferrer">
            {label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default Identity;
